import { useLazyQuery } from "@apollo/client";
import { Box, Button, Pagination, Paper, Stack } from "@mui/material";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import NoDataFound from "shared/molecules/no-data";
import SectionTable from "shared/organisms/tables/table";
import entitesClient from "utils/graphql/entitiesClient";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { table } from "./helper";
import { GET_TOPIC_LIST } from "utils/graphql/services/global-content-hierarchy/queries";
import { TopicFilter } from "./filter";


const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export default function TopicPage() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const classes = useStyles();
  const history = useHistory();
  const [searchPayload, setSearchPayload] = useState({});

  const [clearValuesTrigger] = useState(false);

  const [getTopicList, { loading, error, data }] = useLazyQuery(
    GET_TOPIC_LIST,
    {
      client: entitesClient,
      fetchPolicy: "no-cache",
    }
  );

  const handleChange = (event, value) => {
    setPage(value); // pass new page number to parent
  };

  const handlePreview = (objectId,status) => {
    history.push(`/global-content-hierarchy/topic/update?id=${objectId}&status=${status}`);
  };

  useEffect(() => {
    getTopicList({ variables: { filter: {...searchPayload, page: page, limit } } });
  }, [searchPayload,page, limit]);

  return (
    <>
      <ContentRight>
        <Link to="topic/create" className={classes.label}>
          <Button variant="contained"> Create Topic</Button>
        </Link>
      </ContentRight>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Topics{" "}
      </TypographyHeading>
      <TopicFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />
      <Paper elevation={2} sx={{ px: 2, pb: 4, pt: 2, mt: 2 }}>
        <div>
          {loading && <Loader />}
          {!loading && data?.getTopics?.records?.length > 0 ? (
            <SectionTable
              data={data?.getTopics?.records}
              table={table}
              id="id"
              name="id"
              handlePreview={handlePreview}
              rowsPerPageCount={10}
              style="false"
              totalRecords={data?.getTopics?.meta?.total || 0}
              paginationSegment="false"
              viewSecondaryData="false"
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data" />}</div>
          )}
        </div>
        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={Math.ceil(data?.getTopics?.meta?.total / limit) || 1}
              page={page}
              onChange={handleChange}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
